import styled from '@emotion/styled';
import { transparentize } from 'polished';
import React from 'react';

import type { ModeType } from 'types';
import { useComponentTheme } from '../useComponentTheme';
import { withSpacingStyles } from '../withSpacingStyles';

type Props = {
  value: number,
  height?: string,
  max: number,
  mode?: string,
  schemeMode?: ModeType,
  color: string,
  className: ?string,
};

export const ProgressBar = withSpacingStyles(({ height = '8px', max = 100, value = 0, color, mode, schemeMode = 'light', className }: Props) => {
  const componentTheme = useComponentTheme(theme => theme.components.ProgressBar, mode);
  return (
    <Progress
      className={className}
      color={color}
      data-test="progress-bar"
      height={height}
      max={max}
      schemeMode={schemeMode}
      value={value}
      componentTheme={componentTheme}
    />);
});

const Progress = styled('progress', {
  shouldForwardProp: prop => !['componentTheme', 'height', 'schemeMode'].includes(prop)
})(({ height, schemeMode, componentTheme, theme, color }) => `
  width: 100%;
  height: ${height};
  overflow: hidden;
  border: none;
  border-radius: ${componentTheme.borderRadius};
  background: ${transparentize(0.75, schemeMode === 'dark' ? theme.color.grey : theme.color.lightGrey)};
  vertical-align: middle;
  flex: 1;

  &::-webkit-progress-bar {
    background: inherit;
    border-radius: ${componentTheme.borderRadius};
    transition: width 300ms ease;
  }

  &::-moz-progress-bar {
    border-radius: ${componentTheme.valueRadius};
    background: ${color || theme.color.brand};
    transition: width 300ms ease;
  }

  &::-webkit-progress-value {
    border-radius: ${componentTheme.valueRadius};
    background: ${color || theme.color.brand};
    transition: width 300ms ease;
  }
`);
